export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  shop: "nav-shop",
  howItWorks: "nav-how-it-works",
  professional: "nav-professional",
  support: "nav-support",
  contact: "nav-contact",
  cartButton: "nav-cart-button",
  cartCount: "nav-cart-count",
  mobileMenuToggle: "nav-mobile-menu-toggle",
  buyNow: "nav-buy-now",
};

export const HERO = {
  buyNow: "hero-buy-now",
  learnMore: "hero-learn-more",
};

export const PRODUCT = {
  buyNow: "product-buy-now",
  addToCart: "product-add-to-cart",
  quantityDecrement: "product-qty-decrement",
  quantityIncrement: "product-qty-increment",
  currencySelect: "product-currency-select",
  stickyBuy: "product-sticky-buy",
};

export const CART = {
  drawer: "cart-drawer",
  item: (id) => `cart-item-${id}`,
  remove: (id) => `cart-remove-${id}`,
  qtyInc: (id) => `cart-qty-inc-${id}`,
  qtyDec: (id) => `cart-qty-dec-${id}`,
  checkout: "cart-checkout",
  subtotal: "cart-subtotal",
  countryShip: "cart-country-ship",
  empty: "cart-empty",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  tabProducts: "admin-tab-products",
  tabOrders: "admin-tab-orders",
  tabLeads: "admin-tab-leads",
  tabContact: "admin-tab-contact",
};

export const PROLEAD = {
  form: "prolead-form",
  name: "prolead-name",
  venue: "prolead-venue",
  country: "prolead-country",
  email: "prolead-email",
  phone: "prolead-phone",
  website: "prolead-website",
  bizType: "prolead-biz-type",
  goals: "prolead-goals",
  submit: "prolead-submit",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const QUIZ = {
  start: "quiz-start",
  answer: (i) => `quiz-answer-${i}`,
  result: "quiz-result",
};

export const COOKIE = {
  banner: "cookie-banner",
  accept: "cookie-accept",
  reject: "cookie-reject",
};
